export const urls = {
  GET_KORISNICI_PROGRAMA:
    'KorisniciPrograma/vrati_sve_korisnike_programa_kupca',
  GET_KUPCE: 'Combo/vrati_kupce_combo',
  INSERT_KORISNIK: 'KorisniciPrograma/unos_korisnika_programa',
  UPDATE_KORISNIK: 'KorisniciPrograma/izmena_korisnika_programa',
  DELETE_KORISNIK: 'KorisniciPrograma/brisanje_korisnika_programa',
  GET_KORISNIK_ZA_ID: 'KorisniciPrograma/vrati_korisnika_programa_za_id',
  GET_TIPOVI_MASINA: 'Combo/vrati_tipove_masina_combo',
  GET_MENIJI_INMOLD: 'KorisniciPrograma/vrati_menije_inmold_combo',
  DODELA_MENIJA_INMOLD: 'KorisniciPrograma/dodela_menija_inmold',
};
